export default __webpack_public_path__ + "static/media/landing-page.8cbd892d.png";